/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccessDeniedExceptionResponse,
  GetMyActiveGoodHabit200Response,
  InternalServerErrorExceptionResponse,
  UserDetailResponse,
  UserGoodhabitsUnassignedResponse,
} from '../models/index';
import {
    AccessDeniedExceptionResponseFromJSON,
    AccessDeniedExceptionResponseToJSON,
    GetMyActiveGoodHabit200ResponseFromJSON,
    GetMyActiveGoodHabit200ResponseToJSON,
    InternalServerErrorExceptionResponseFromJSON,
    InternalServerErrorExceptionResponseToJSON,
    UserDetailResponseFromJSON,
    UserDetailResponseToJSON,
    UserGoodhabitsUnassignedResponseFromJSON,
    UserGoodhabitsUnassignedResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class MeApi extends runtime.BaseAPI {

    /**
     * At the moment, this particular route is outside REST API namespace. It is stateful and uses session cookie (`PHPSESSID`). Response may contain `Set-Cookie` header with new `PHPSESSID`. Once JWT is implemented, this route should be part of `/api/` namespace and rely on JWT, rather than on session.
     * Info about current user
     */
    async getMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDetailResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/apijs/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDetailResponseFromJSON(jsonValue));
    }

    /**
     * At the moment, this particular route is outside REST API namespace. It is stateful and uses session cookie (`PHPSESSID`). Response may contain `Set-Cookie` header with new `PHPSESSID`. Once JWT is implemented, this route should be part of `/api/` namespace and rely on JWT, rather than on session.
     * Info about current user
     */
    async getMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDetailResponse> {
        const response = await this.getMeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMyActiveGoodHabitRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyActiveGoodHabit200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/apijs/me/goodhabits/active`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMyActiveGoodHabit200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getMyActiveGoodHabit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyActiveGoodHabit200Response> {
        const response = await this.getMyActiveGoodHabitRaw(initOverrides);
        return await response.value();
    }

    /**
     * List of user\'s unassigned goodhabits
     */
    async getMyUnassignedGoodhabitsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGoodhabitsUnassignedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/apijs/me/goodhabits/unassigned`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGoodhabitsUnassignedResponseFromJSON(jsonValue));
    }

    /**
     * List of user\'s unassigned goodhabits
     */
    async getMyUnassignedGoodhabits(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGoodhabitsUnassignedResponse> {
        const response = await this.getMyUnassignedGoodhabitsRaw(initOverrides);
        return await response.value();
    }

}
